(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canard-careers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'canard-careers-last-modal'
    const PENDING_KEY = 'canard-careers-pending-submit'
    const SUCCESS_MODAL_KEY = 'canard-careers-success-modal-id'

    const syncPreRolesCollapsedHeights = () => {
      document.querySelectorAll('.canard-careers__pre-roles-grid').forEach((grid) => {
        const openCallout = grid.querySelector('.canard-careers__open-callout')
        const finePrint = grid.querySelector('.canard-careers__fine-print')
        const finePrintExtra = grid.querySelector('[data-fine-print-extra]')

        if (!openCallout || !finePrint) return

        // Measure a true collapsed state, even if fine print is currently expanded.
        const previousHidden = finePrintExtra ? finePrintExtra.hidden : true
        if (finePrintExtra) finePrintExtra.hidden = true

        openCallout.style.minHeight = '0'
        finePrint.style.minHeight = '0'

        const targetHeight = Math.max(openCallout.offsetHeight, finePrint.offsetHeight)
        openCallout.style.minHeight = `${targetHeight}px`
        finePrint.style.minHeight = `${targetHeight}px`

        if (finePrintExtra) finePrintExtra.hidden = previousHidden
      })
    }

    const closeModal = (modal) => {
      if (!modal) return
      modal.hidden = true
      modal.setAttribute('aria-hidden', 'true')
      const trigger = document.querySelector(`[data-careers-open="${modal.id}"]`)
      if (trigger) trigger.setAttribute('aria-expanded', 'false')
    }

    const openModal = (modal) => {
      if (!modal) return
      modal.hidden = false
      modal.setAttribute('aria-hidden', 'false')
      const trigger = document.querySelector(`[data-careers-open="${modal.id}"]`)
      if (trigger) trigger.setAttribute('aria-expanded', 'true')
      const firstInput = modal.querySelector('input, textarea, select, button')
      if (firstInput) firstInput.focus()
    }

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-careers-open]')
      if (openTrigger) {
        const modal = document.getElementById(openTrigger.dataset.careersOpen)
        openModal(modal)
        return
      }

      const closeTrigger = event.target.closest('[data-careers-close]')
      if (closeTrigger) {
        const modal = document.getElementById(closeTrigger.dataset.careersClose)
        closeModal(modal)
        return
      }

      const modal = event.target.closest('[data-careers-modal]')
      if (modal && event.target === modal) closeModal(modal)
    })

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return
      const openModalElement = document.querySelector('[data-careers-modal]:not([hidden])')
      closeModal(openModalElement)
    })

    // Persist which modal was submitted so we can reopen it after Shopify redirects.
    document.querySelectorAll('.canard-careers__form').forEach((form) => {
      form.addEventListener('submit', () => {
        const modal = form.closest('[data-careers-modal]')
        if (modal) {
          sessionStorage.setItem(STORAGE_KEY, modal.id)
          sessionStorage.setItem(PENDING_KEY, '1')
          const section = form.closest('.canard-careers')
          const successModal = section?.querySelector('[id^="CareersSuccessModal-"]')
          if (successModal) sessionStorage.setItem(SUCCESS_MODAL_KEY, successModal.id)
        }
      })
    })

    const reopenedModalId = sessionStorage.getItem(STORAGE_KEY)
    const pendingSubmit = sessionStorage.getItem(PENDING_KEY) === '1'
    const successModalId = sessionStorage.getItem(SUCCESS_MODAL_KEY)

    if (reopenedModalId && pendingSubmit) {
      const sourceModal = document.getElementById(reopenedModalId)
      if (sourceModal) closeModal(sourceModal)

      const successModal = successModalId ? document.getElementById(successModalId) : null
      if (successModal) {
        openModal(successModal)
      }
    } else {
      document.querySelectorAll('.canard-careers__success, .canard-careers__error').forEach((notice) => {
        const modal = notice.closest('[data-careers-modal]')
        if (modal) openModal(modal)
      })
    }

    sessionStorage.removeItem(STORAGE_KEY)
    sessionStorage.removeItem(PENDING_KEY)
    sessionStorage.removeItem(SUCCESS_MODAL_KEY)

    document.querySelectorAll('[data-fine-print]').forEach((wrapper) => {
      const toggle = wrapper.querySelector('[data-fine-print-toggle]')
      const extra = wrapper.querySelector('[data-fine-print-extra]')
      if (!toggle || !extra) return

      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
        extra.hidden = isExpanded
        toggle.setAttribute('aria-expanded', String(!isExpanded))
        toggle.textContent = isExpanded ? '+' : '−'
      })
    })

    syncPreRolesCollapsedHeights()
    window.addEventListener('resize', syncPreRolesCollapsedHeights)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
